/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ChargeTypeEnum = 'FLAT_FEE' | 'PER_UNIT' | 'STANDARD' | 'TIERED';

export const ChargeTypeEnum = {

    FLAT_FEE: 'FLAT_FEE' as ChargeTypeEnum,

    PER_UNIT: 'PER_UNIT' as ChargeTypeEnum,

    STANDARD: 'STANDARD' as ChargeTypeEnum,

    TIERED: 'TIERED' as ChargeTypeEnum
};

